import api from "../utils/apiServices";

export default function handlePostApi(url, requestData) {
  // console.log("posted data", requestData)
  return api.post(url, requestData);
}
